<template>
    <div class="logistics">
        <!-- 物流弹框 -->
        <el-dialog title="完整物流" :visible.sync="dialogLogisticsVisible" class="all_logistics">
        <div class="express-info">
            <span>{{row.delivery_courier}}</span>
            <span class="ml-8">{{info.logistics_number}}</span>
            <el-button size="mini" @click="copy" class="ml-8">复制</el-button>
            <div class="time-line mt-18">
                <el-timeline>
                    <el-timeline-item
                    v-for="(item, index) in showList"
                    :key="index"
                    :icon="index == 0 ? '' : 'ring'"
                    :type="item.type"
                    color="#0053DB"
                    :size="item.size">
                    <p>{{item.status}}</p>
                    <p class="des">{{item.context}}</p>
                    <p class="des">{{ item.time }}</p>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogLogisticsVisible = false">我知道了</el-button>
        </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogLogisticsVisible: false,
            info: [], //物流信息
            showList: [],
            row: {}
        }
    },
    methods: {
        logisticsInit(row) {
            this.row = row
            this.showList = row.delivery_info?.delivery_logistics
            this.dialogLogisticsVisible = true
        },
        copy() {
            var inputTest = document.createElement("textarea");
            inputTest.value = this.info.logistics_number;
            document.body.appendChild(inputTest);
            inputTest.select();
            document.execCommand("Copy");
            inputTest.className = "oInput";
            inputTest.style.display = "none";
            this.$message.success("复制成功");
            document.body.removeChild(inputTest);
        }
    }
}
</script>
<style lang="less" scoped>
.all_logistics{
  /deep/ .el-dialog {
    width: 600px;
  }
  /deep/ .el-dialog__body {
    max-height: 500px;
    overflow: auto;
    padding: 0 0 0 20px;
  }
  /deep/ .el-dialog__header {
    border-bottom: none;
  }
  /deep/ .el-dialog__footer {
    padding: 0px 20px 20px;
  }
}
.express-info {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
}
/deep/.el-button--mini {
    padding: 0 6px;
    line-height: 20px;
}
.des {
    font-size: 12px;
    color: #666666;
}
.el-timeline-item {
    padding-bottom: 1px;
}
/deep/ .ring{
    width: 6px;
    height: 6px;
    background-color: #fff;
    border-radius: 50%;
}
</style>